import * as React from 'react'
import { compose, pure } from 'recompose'

import { ChoiceStatus } from '../../../../commons/ChoiceStatus'
import { QuestionType } from '../../../../commons/EditorStatus'
import QuestionEntity from '../../../../commons/entity/QuestionEntity'
import QuestionChoice from '..//QuestionChoice/QuestionChoice'
import * as styles from './QuestionChoiceSet.css'

interface QuestionChoiceSetProps {
  isEnabled?: boolean
  question: QuestionEntity
  answerChoiceId?: number
  answerCount?: { [key: string]: number }
  postAnswer: (data: any) => void
}

const QuestionChoiceSet: React.FunctionComponent<QuestionChoiceSetProps> = ({
  question,
  answerChoiceId,
  postAnswer,
  isEnabled = true,
  answerCount
}) => {
  type Element = React.ReactElement<any>
  const buttons: Element[] = []

  const listClass =
    question.question_type === QuestionType.TRUEFALSE.value ? styles.trueFalseList : styles.fourChoiceList
  const itemClass =
    question.question_type === QuestionType.TRUEFALSE.value ? styles.trueFalseItem : styles.fourChoiceItem

  const choicedId = question.choicedId
  question.choices.forEach((choice, index) => {
    let choiceStatus = ChoiceStatus.NORMAL

    // 回答済み
    if (answerChoiceId == null && choicedId) {
      choiceStatus = choice.id === choicedId ? ChoiceStatus.SELECTED : ChoiceStatus.NORMAL
    }

    // 正解時
    if (answerChoiceId && choicedId && answerChoiceId === choicedId) {
      choiceStatus = choice.id === answerChoiceId ? ChoiceStatus.CORRECT : ChoiceStatus.TRANSPARENT
    }

    // 不正解時
    if (answerChoiceId && answerChoiceId !== choicedId) {
      if (answerChoiceId === choice.id) {
        choiceStatus = ChoiceStatus.CORRECT
      } else if (choicedId === choice.id) {
        choiceStatus = ChoiceStatus.FAILURE
      } else {
        choiceStatus = ChoiceStatus.TRANSPARENT
      }
    }

    // 回答数公開
    let answeredCount
    let answerTotalCount
    if (answerCount) {
      answeredCount = answerCount[String(choice.id)] || 0
      answerTotalCount = 0
      for (const key in answerCount) {
        if (answerCount.hasOwnProperty(key)) {
          answerTotalCount += answerCount[key] || 0
        }
      }
    }

    buttons.push(
      <div key={`choice-${choice.id}`} className={itemClass} id={`choice-${index + 1}`}>
        <QuestionChoice
          type={question.question_type}
          handleClick={() => postAnswer({ questionId: question.id, choiceId: choice.id })}
          isEnabled={isEnabled}
          src={choice.image}
          isMaru={index === 0}
          choiceStatus={choiceStatus}
          answerCount={answeredCount}
          answerTotalCount={answerTotalCount}
        >
          {choice.title}
        </QuestionChoice>
      </div>
    )
  })

  return <div className={listClass}>{buttons}</div>
}

export default compose<QuestionChoiceSetProps, QuestionChoiceSetProps>(pure)(QuestionChoiceSet)
